import { FccOperatorRoleType } from '@backoffice-frontend/graphql'
import { BoumRight } from '@moia-dev/moia-token-claims'

/**
 * The right that permits going on duty in the remote operations area of a given
 * operator role.
 */
export const roleLoginRight: Record<FccOperatorRoleType, BoumRight> = {
  [FccOperatorRoleType.RiderSupport]: BoumRight.RIDER_SUPPORT_LOGIN,
  [FccOperatorRoleType.RemoteAssistanceOperator]:
    BoumRight.REMOTE_ASSISTANCE_OPERATOR_LOGIN,
}
